import type { GroupBase, DropdownIndicatorProps } from "react-select";
import Select, { components } from "react-select";
import {
  MagnifyingGlassIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import type { Props } from "react-select";
import AsyncSelect from "react-select/async";
import { getTagsLIstSeach, getAuthorsListSearch } from "~/api";

const colourStyles = {
  multiValue: (styles: any) => ({
    ...styles,
    color: "#050E3D",
    backgroundColor: "#fff",
    padding: "3px 5px",
    fontWeight: "",
    marginRight: 6,
    borderRadius: 15,
    border: "1px solid rgba(151,151,151, 1)",
    // "&:hover": {
    //   backgroundColor: "#F35D26",
    // },
  }),

  // MultiValueRemove controll the x icon when closing selected value
  MultiValueRemove: (base: any, state: any) => ({
    ...base,
    cursor: "pointer",
    padding: "2px 5px",
    borderRadius: 15,
    "&:hover": {
      backgroundColor: state.iselected ? "#000" : "#000",
      color: "#fff",
    },
  }),
  control: (styles: any, state: any) => ({
    ...styles,
    border: "1px solid #E9E9E9",
    borderRadius: "6px",
    width: "100%",
    backgroundColor: state.isDisabled ? "#E9E9E9" : "#ffffff",
    color: state.isDisabled ? "#E9E9E9" : "#2A2A2A",
  }),
  input: (base: any) => ({
    ...base,
    "input:focus": {
      boxShadow: "none",
    },
  }),

  dropdownIndicator: (styles: any) => ({
    ...styles,
    padding: "14px 16px 14px 16px",
    "&:hover": {
      backgroundColor: "#F6F6F6",
    },
  }),
};

export function CustomSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  name,
  placeholder,
  value,
  options,
  id,
  isDisabled,
  getOptionLabel,
  onChange,
  //@ts-ignore
  isAsync,
}: Props<Option, IsMulti, Group>) {
  // console.log("value", value);

  // we'r doing the request in the frontend because the axios instance is not available in the frontend (axios.server.ts)
  const promiseOptions = async (inputValue: string) => {
    // Determine which search function to use based on the field name
    const searchFunction =
      name === "authorIds" ? getAuthorsListSearch : getTagsLIstSeach;
    const data = await searchFunction(inputValue);

    // Return the appropriate property based on the field name
    if (name === "authorIds") {
      return data?.authors || options;
    }
    return data?.tags || options;
  };

  const handleChangeFieldValue = (newSelection: any, e: any) => {
    // console.log("<EEEEE>", e, newSelection);

    if (typeof onChange === "function") {
      let newOptionValue;
      if (e.action === "clear") {
        newOptionValue = e.removedValues;
      } else if (e.action === "remove-value") {
        newOptionValue = e.removedValue;
      } else {
        newOptionValue = e.option;
      }
      let valueObj = {
        target: {
          name: newOptionValue?.name,
          id: id,
          value: newOptionValue,
          checked: e.action === "remove-value" ? false : true,
        },
      };

      //@ts-ignore
      onChange(valueObj, newOptionValue, newSelection);
    }
  };
  const DropdownIndicator = (props: DropdownIndicatorProps<any, true>) => {
    const isWeiterFilterSelect = name === "authorIds" || name === "tagIds";
    return (
      <components.DropdownIndicator {...props}>
        {isWeiterFilterSelect ? (
          <MagnifyingGlassIcon className="h-5 w-5 text-primary" />
        ) : (
          <ChevronDownIcon className="h-5 w-5 text-primary" />
        )}
      </components.DropdownIndicator>
    );
  };
  return (
    <>
      {isAsync ? (
        <AsyncSelect
          onChange={handleChangeFieldValue}
          components={{
            //@ts-ignore
            DropdownIndicator,
            IndicatorSeparator: null,
          }}
          styles={colourStyles}
          isClearable={false}
          isMulti
          value={value}
          name={name}
          isDisabled={isDisabled}
          cacheOptions
          defaultOptions={options}
          id={id}
          placeholder={placeholder}
          loadOptions={promiseOptions}
          getOptionValue={(option: any) => option.id}
          getOptionLabel={
            getOptionLabel && typeof getOptionLabel === "function"
              ? getOptionLabel
              : (option: any) => option.name
          }
          theme={(theme) => ({
            ...theme,
            borderRadius: 8,
            colors: {
              ...theme.colors,
              primary25: "#F6F6F6",
              primary: "#F35D26",
              neutral50: "#2A2A2A",
            },
          })}
        />
      ) : (
        <Select
          components={{
            //@ts-ignore
            DropdownIndicator,
            IndicatorSeparator: null,
          }}
          placeholder={placeholder}
          isMulti
          isClearable={false}
          id={id}
          options={options}
          isDisabled={isDisabled}
          //@ts-ignore
          // defaultValue={defaultInputValue}
          name={name}
          value={value}
          getOptionLabel={
            getOptionLabel && typeof getOptionLabel === "function"
              ? getOptionLabel
              : (option: any) => option.name
          }
          getOptionValue={(option: any) => option.id}
          onChange={handleChangeFieldValue}
          styles={colourStyles}
          theme={(theme) => ({
            ...theme,
            borderRadius: 8,
            colors: {
              ...theme.colors,
              primary25: "#F6F6F6",
              primary: "#F35D26",
              neutral50: "#2A2A2A",
            },
          })}
        />
      )}
    </>
  );
}
